import React from "react";

export function WorkDetails() {
	return <div>Work Details</div>;
}
